import {Side, Turn, Align} from './index.h'

export const SIDE: {
  [K in Side]: Side
} = {
  UP: 'UP',
  RIGHT: 'RIGHT',
  DOWN: 'DOWN',
  LEFT: 'LEFT'
}

export const TURN: {
  [K in Turn]: Turn
} = {
  RIGHT: 'RIGHT',
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  STOP: 'STOP'
}

export const ALIGN: {
  UP: Align
  RIGHT: Align
  DOWN: Align
  LEFT: Align
  CENTER: Align
} = {
  UP: 'UP',
  RIGHT: 'RIGHT',
  DOWN: 'DOWN',
  LEFT: 'LEFT',
  CENTER: 'VERT CENTER'
}
